var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-gray-100 text-blue-600"},[_vm._v(" Hello Tailwind in Vue 2! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }